/* Neponia: GIF-style loop videos. Lazy, paused off-screen, hero after page load. */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var conn = navigator.connection || {};
  if ((mq && mq.matches) || conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;

  function play(v) {
    var s = v.querySelector('source[data-src]');
    if (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); v.load(); }
    if (!v.__abBound) {
      v.__abBound = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) play(v);
      else if (!v.paused) v.pause();
    });
  }, { rootMargin: '300px 0px' }) : null;

  function watch(list) {
    Array.prototype.forEach.call(list, function (v) {
      if (v.__abWatched) return;
      v.__abWatched = true;
      if (io) io.observe(v); else play(v);
    });
  }

  function idle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 1500 });
    else setTimeout(fn, 300);
  }

  watch(document.querySelectorAll('video[data-ab-lazy-video]'));
  function hero() { watch(document.querySelectorAll('video[data-ab-hero-video]')); }
  if (document.readyState === 'complete') idle(hero);
  else window.addEventListener('load', function () { idle(hero); });

  document.addEventListener('shopify:section:load', function (e) {
    watch(e.target.querySelectorAll('video[data-ab-lazy-video], video[data-ab-hero-video]'));
  });
})();
